var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-forgotten-footer"},[_c('a',{staticClass:"account-forgotten-footer__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onCancel($event)}}},[_vm._v("\n    "+_vm._s(_vm.$txt('account-forgotten.footer.cancel'))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1863c082","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/account-forgotten/footer/footer.vue
// module id = n3z+
// module chunks = 0